"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.LowStockNotificationAPI = {
    getLowStockNotifications: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/user/me/lowStockNotifications").then(function (response) {
            var notifications = response.data.data;
            return notifications;
        });
    },
    addLowStockNotification: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/user/me/lowStockNotifications", createObject)
            .then(function (response) {
            var notification = response.data;
            return notification;
        });
    },
    deleteLowStockNotification: function (companyId, lowStockNotificationId) {
        return index_1.axios.delete("/api/v1/company/" + companyId + "/user/me/lowStockNotification/" + lowStockNotificationId)
            .then(function () {
        });
    },
};
//# sourceMappingURL=LowStockNotificationAPI.js.map